import { render, staticRenderFns } from "./userPageLab.vue?vue&type=template&id=476dfc24&scoped=true"
import script from "./userPageLab.vue?vue&type=script&lang=js"
export * from "./userPageLab.vue?vue&type=script&lang=js"
import style0 from "./userPageLab.vue?vue&type=style&index=0&id=476dfc24&prod&lang=scss"
import style1 from "./userPageLab.vue?vue&type=style&index=1&id=476dfc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476dfc24",
  null
  
)

export default component.exports